import { render, staticRenderFns } from "./CmaDashboard.vue?vue&type=template&id=68c97caa&scoped=true&"
import script from "./CmaDashboard.vue?vue&type=script&lang=js&"
export * from "./CmaDashboard.vue?vue&type=script&lang=js&"
import style0 from "./CmaDashboard.vue?vue&type=style&index=0&id=68c97caa&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c97caa",
  null
  
)

export default component.exports